import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { INTEREST_TAGS, PERSONALITY_TAGS } from "./tag";
import useUserStore from "@store/useUserStore";
import { updateUserData } from "api/user";
import { useSnackbar } from "contexts/SnackbarContext";

const MyInterest = () => {
    const navigate = useNavigate();
    const setUserInfo = useUserStore((state) => state.setUserInfo);
    const userInfo = useUserStore((state) => state.userInfo);
    const [step, setStep] = useState(1);
    const [selectedTags, setSelectedTags] = useState([]);

    const { showSuccess, showError } = useSnackbar();
    const handleTagClick = (tag) => {
        if (selectedTags.includes(tag)) {
            setSelectedTags(selectedTags.filter((t) => t !== tag));
        } else {
            if (selectedTags.length >= 4) return;
            setSelectedTags([...selectedTags, tag]);
        }
    };

    const updateUserTags = () => {
        updateUserData({ tags: selectedTags }).then((res) => {
            if (res.code === "0000") {
                setUserInfo({ ...userInfo, tags: selectedTags });
                showSuccess("태그 수정이 완료되었습니다.");
                navigate("/mybuccl");
            } else {
                showError(res.message);
            }
        });
    };

    return (
        <div className="my-interest-page">
            <div>
                {step === 1 && (
                    <>
                        <h2 className="title">어떤 주제에 관심이 있나요?</h2>
                        <p className="title-sub">
                            가장 관심있는 주제를 하나만 선택해주세요.
                        </p>
                        <div className="user-tag-wrap">
                            {INTEREST_TAGS.map((tag) => (
                                <div
                                    key={tag}
                                    className={`user-tag ${
                                        selectedTags.includes(tag)
                                            ? "selected"
                                            : ""
                                    }`}
                                    onClick={() => {
                                        handleTagClick(tag);
                                    }}
                                >
                                    {tag}
                                </div>
                            ))}
                        </div>
                    </>
                )}
                {step === 2 && (
                    <>
                        <h2 className="title">나는 어떤 사람인가요?</h2>
                        <p className="title-sub">
                            나를 나타낼 수 있는 키워드를 선택해주세요.(최대 3개)
                        </p>
                        <div className="user-tag-wrap ">
                            {PERSONALITY_TAGS.map((tag) => (
                                <div
                                    key={tag}
                                    className={`user-tag ${
                                        selectedTags.includes(tag)
                                            ? "selected"
                                            : ""
                                    }`}
                                    onClick={() => {
                                        handleTagClick(tag);
                                    }}
                                >
                                    {tag}
                                </div>
                            ))}
                        </div>
                    </>
                )}

                <button
                    className={`btn  btn-full btn-large ${
                        selectedTags.length === 0
                            ? "btn-disabled"
                            : "btn-purple500"
                    }`}
                    onClick={() => {
                        if (step === 1) {
                            setStep(2);
                        } else {
                            updateUserTags();
                        }
                    }}
                >
                    {step === 1 ? "다음" : "완료"}
                </button>
            </div>
        </div>
    );
};

export default MyInterest;
